import {el, on, tagName, template} from "../adapters/backbone-decorators";
import i18n from 'l10n';
import {_} from 'backboneAdapter'
import GenericView from 'js/views/generic.view';
import GroupModel from 'js/models/group.model';
import Template from 'js/templates/group.info.action.hbs';
import CampaignConfiguration from 'js/models/campaign.config.model';
import UserModel from 'js/models/userrelatedinfo.model';
import dhtmlx from 'dhtmlxAdapter';
import Queryable from 'js/traits/queryable.trait';
import InnerView from 'js/views/subscribers.list.view';
import Maybe from 'js/traits/maybe.type';

const tellody = require('tellody').parser;

require('interfaceAdapter');
require('metroHelpers');

const texts = {
    'None': i18n.t('nonExistingGroupDeletion'),
    'Error': i18n.t('groupDeletionUnsuccessful'),
    'OK': i18n.t('groupDeletionSuccessful'),
    'undefined': ''
};

@el("#group-info-actions")
@tagName('span')
@template(Template)
class GroupInfoView extends GenericView {

    constructor(options) {
        super(options);
        this.options = options;
        _.extend(this, Queryable);
        tellody.yy.parseError = tellody.parseError;
        this.model = new GroupModel({id: this.id});
        this.model.bind("change", this.render, this);
        this.loadGroup();
    }

    async render() {
        await this.initFilters(this.id);
        const qbHandler = () => {
            var result = $('#builder-plugins').queryBuilder('getRules');

            if (!$.isEmptyObject(result)) {
                console.log(JSON.stringify(result, null, 2));
                let parsedQuery = this.rulesToParsedQuery(result);
                console.log(JSON.stringify(parsedQuery, null, 2));
                let query = this.parsedQueryToQuery(parsedQuery, false);
                console.log(query);
                this.model.saveAttribute('query', query, (at, v, outcome) => {
                    if (outcome === "OK") {
                        const parsedQuery = tellody.parse(this.model.get('query'));
                        this.model.set('parsedQuery', parsedQuery);
                        this.innerView = new InnerView({groupModel: this.model});
                        this.innerView.load({postpaid: this.options.postpaid, groupId: this.id});
                        // this.render();
                    }
                });
            }
        };

        super.render();
        this.$('[data-i18n]').i18n();
        if (this.model.get("description") === '') {
            let parsedQuery = this.model.get("parsedQuery");
            if (parsedQuery) {
                var rules_plugins = this.parsedQueryToRules(parsedQuery);
                if (rules_plugins) {
                    this.$('#builder-plugins').queryBuilder(this.queryBuilderOptions);

                    this.$('#builder-plugins').queryBuilder('setRules', rules_plugins);

                    this.$('#btn-get').show().on('click', qbHandler);
                }
            }
        }

        const groupName = this.model.get("title");
        if (groupName) {
            $("#groupInfoIcon").text(groupName.toUpperCase().charAt(0) + groupName.toLowerCase().charAt(1));
        } else {
            $("#groupInfoIcon").html('<i class="icon icon-tellody-group"></i>');
        }
        $('#composeMessage').on('click', this.toggleVisibility);

        this.loadGroupRating(this.model.get("id"));
    }

    updateCallback(attributeName, value, outcome, e, settings) {
        if ("OK" === outcome) {
            if (attributeName === 'title') {
                if (value) {
                    $("#groupInfoIcon").text(value.toUpperCase().charAt(0) + value.toLowerCase().charAt(1));
                } else {
                    $("#groupInfoIcon").html('<i class="icon icon-tellody-group"></i>');
                }
            }
        }
        return super.updateCallback(attributeName, value, outcome, e, settings);
    }

    async deleteCallback(data) {
        await dhtmlx.alert(texts[Maybe(data).bind(d => d.outcome).maybe(undefined, o => o)]);
        location.href = "Contacts.htm";
    }

    toggleVisibility() {
        const e = $('#sendmessagefloatingbutton');
        if (e.css("display") === 'block') {
            e.css("display", "none");
        } else {
            e.css("display", "block");
        }
    }

    loadGroup() {
        const self = this;
        this.model.fetch({
            success: (model, data) => {
                if (data && data.outcome && data.outcome !== 'OK') {
                    $.Notify.error(i18n.t('groups.retrievingerror') + ': ' + (data.reason ? data.reason : ''));
                } else {
                    if (model.get('groupType') === 'query') {
                        try {
                            const parsedQuery = tellody.parse(model.get('query'));
                            model.set('parsedQuery', parsedQuery);
                        } catch (e) {
                            console.error(e);
                        }
                    }
                    $.ajaxDefaultQ({
                        url: self.model.url() + '/referenced',
                        type: 'get',
                        dataType: 'json'
                    }).done((data) => {
                        if (data) {
                            const deletionBtn = self.$('.delete');
                            deletionBtn.attr('title', i18n.t('groups.cannotdelete'));
                            deletionBtn.prop("disabled", true);
                            deletionBtn.unbind('click');
                            deletionBtn.css('cursor', 'not-allowed');
                        }
                    });
                }
            },
            error: (data) => {
                $.Notify.error(i18n.t('groups.retrievingerrorstatus') + ' = ' + (data.status ? data.status : ''));
            }
        });
    }

    loadGroupRating(id) {
        $.ajaxDefaultQ({
            url: `/CampaignCloud/Report/${id}/getGroupSatisfactionAndEngagement`,
            dataType: "json"
        }).done((response) => {
            if (!response) {
                return;
            }
            const [satScore, engScore] = response;

            function printableScore(score) {
                const scoreDecimal = (score || 0) * 10;
                return scoreDecimal > 0 ? (scoreDecimal) % 1 === 0 ? scoreDecimal * 10 : (scoreDecimal).toFixed(2) : '-';
            }

            const engagement = printableScore(engScore);
            const satisfaction = printableScore(satScore);
            $("#groupSatisfaction").find(".metricValue ").html(satisfaction);
            $("#groupEngagement").find(".metricValue ").html(engagement);

        }).fail((re) => {
            console.error(re);
        });
    }

    @on('click #send-sms', _, 'SMS')
    @on('click #send-email', _, 'EMAIL')
    async sendMessage(ev, channel) {
        const self = this;
        const CCmodel = new CampaignConfiguration({campaignChannel: channel});
        const userModel = new UserModel();
        try {
            await userModel.fetch();
            CCmodel.set("userId", userModel.id);
            CCmodel.set("sender", ((channel === 'SMS') ?
                userModel.get("username").replace(/\./g, "").substring(0, 11) :
                userModel.get("username")));
            const attr = "includedGroups";
            const existingGroups = CCmodel.get(attr);
            existingGroups.push(`Group${self.model.get("id")}`);
            CCmodel.set(attr, existingGroups);
            const {id: ccModelId} = await CCmodel.save(CCmodel.attributes);
            location.href = `Message.htm#${ccModelId}`;
        } catch (error) {
            console.error(error);
        }
        return false;
    }
}

export default GroupInfoView;
